
import { ITraveler } from "@common/models/Traveler";
import { FieldType, Model, Schema } from "@core/index";
import { IOriginDestination } from "./OriginDestination";
import { IPerson } from "./Person";


export interface IAncillaryAvailabilityRequest {
    mode?: string;
    originDestinations?: IOriginDestination[],
    travelers?: ITraveler[],
    contactInfo?: IPerson
    jsessionId?: string,
    transactionIdentifier?: string,
    pnr?: string
}

export class AncillaryAvailabilityRequest extends Model implements IAncillaryAvailabilityRequest {
    public static schema: Schema = new Schema("AvailabilityRequest");
    public mode?: string;
    public transactionIdentifier?: string;
    public jsessionId?: string;
    public originDestinations?: IOriginDestination[];
    public travelers?: ITraveler[];
    public contactInfo?: IPerson;


    constructor(values: IAncillaryAvailabilityRequest) {
        super(AncillaryAvailabilityRequest.schema);
        this.setValues(values);
    }
}

AncillaryAvailabilityRequest.schema.addField("id").type(FieldType.Integer).primary();
AncillaryAvailabilityRequest.schema.addField("mode").type(FieldType.String).required();
AncillaryAvailabilityRequest.schema.addField("originDestinations").type(FieldType.List);
AncillaryAvailabilityRequest.schema.addField("transactionIdentifier").type(FieldType.String).required();
AncillaryAvailabilityRequest.schema.addField("jsessionId").type(FieldType.String).required();
AncillaryAvailabilityRequest.schema.addField("travelers").type(FieldType.List).required();
AncillaryAvailabilityRequest.schema.addField("contactInfo").type(FieldType.Object);

